module.exports = __webpack_public_path__ + "img/fourth.48c5b4c2.svg";